import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: "María González",
      location: "Buenos Aires",
      comment: "Trajeron el pulpo a casa, producto premium. ¡Super recomendados! La calidad es excepcional, fresco y con un sabor increíble.",
      rating: 5,
      product: "Pulpo Patagónico"
    },
    {
      name: "Carlos Ramírez",
      location: "Mar del Plata",
      comment: "Las ostras vivas son una experiencia única. La frescura y calidad son incomparables. Excelente servicio de entrega.",
      rating: 5,
      product: "Ostras Vivas"
    },
    {
      name: "Laura Fernández",
      location: "Rosario",
      comment: "El langostino L1 de exportación es simplemente perfecto. La mejor calidad que he probado en Argentina.",
      rating: 5,
      product: "Langostinos L1"
    }
  ];

  return (
    <section id="testimonios" className="py-20 relative overflow-hidden bg-deep-50">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-deep-100 via-deep-50 to-deep-100" />
      
      {/* Floating elements */}
      <div className="absolute top-20 right-10 w-32 h-32 bg-gradient-to-r from-ocean-500/10 to-jade-500/10 rounded-full blur-xl" />
      <div className="absolute bottom-32 left-16 w-40 h-40 bg-gradient-to-r from-jade-500/10 to-ocean-500/10 rounded-full blur-xl" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-transparent bg-gradient-to-r from-ocean-500 to-jade-500 bg-clip-text font-heading mb-6">
            Clientes Satisfechos
          </h2>
          <p className="text-xl text-pearl-700 max-w-3xl mx-auto">
            Lo que dicen nuestros clientes sobre la calidad de nuestros productos marinos
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, scale: 1.02 }}
              className="relative"
            >
              <div className="bg-deep-200/60 backdrop-blur-lg p-8 rounded-2xl shadow-xl border border-ocean-500/30 h-full flex flex-col">
                {/* Quote Icon */}
                <div className="mb-4">
                  <Quote className="w-10 h-10 text-ocean-500 opacity-50" />
                </div>
                
                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-ocean-500 text-ocean-500" />
                  ))}
                </div>
                
                {/* Comment */}
                <p className="text-pearl-700 leading-relaxed mb-6 flex-grow italic">
                  "{testimonial.comment}"
                </p>
                
                {/* Product Tag */}
                <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-ocean-500/20 rounded-full text-ocean-500 text-sm font-medium mb-4 w-fit">
                  {testimonial.product}
                </div>
                
                {/* Author */}
                <div className="pt-4 border-t border-ocean-500/20">
                  <p className="font-semibold text-ocean-500 mb-1">{testimonial.name}</p>
                  <p className="text-sm text-pearl-600">{testimonial.location}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <p className="text-lg text-pearl-700 mb-6">
            ¿Querés compartir tu experiencia con Mar de Jade?
          </p>
          <motion.a
            href="https://wa.me/5491160065484"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-block bg-gradient-to-r from-ocean-500 to-jade-500 text-white px-8 py-3 rounded-full font-semibold text-lg hover:from-ocean-600 hover:to-jade-600 transition-all duration-300 shadow-lg"
          >
            Contáctanos
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
